import {createSelector} from "reselect";
import {sliderSelectorKeys} from "./selectorKeys";

const slider_S = state => state.slider;

const creatorFn = selectorKey => {
    return createSelector(slider_S, data => data[selectorKey])
};

export const sliderSelectors = state => {
    const sData = {};

    sliderSelectorKeys.forEach(key => {
        sData[key] = creatorFn(key)(state)
    });

    return sData;
};